import { Component, OnInit, Input } from '@angular/core';
import { Benefit, BenefitService, ErrorStateService } from '@fgb/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';

enum BUTTON_STATUS {
  AddBenefit,
  OutOfStock,
  ComingSoon,
  Expiried,
}

@Component({
  selector: 'fgb-benefit-info-modal',
  templateUrl: './benefit-info-modal.component.html',
  styleUrls: ['./benefit-info-modal.component.scss'],
})
export class BenefitInfoModalComponent implements OnInit {
  @Input() benefit: Benefit;
  @Input() numberClaimed: number;
  @Input() classifyStatusOfBenefit: number;
  @Input() claimLimit: number | null;
  BUTTON_STATUS = BUTTON_STATUS;

  constructor(
    private activeModal: NgbActiveModal,
    private benefitService: BenefitService,
    private errorService: ErrorStateService
  ) {}

  ngOnInit() {}

  closeModal(): void {
    this.activeModal.close();
  }

  claimBenefit() {
    firstValueFrom(this.benefitService.claimBenefit(this.benefit))
      .then(() => this.closeModal())
      .catch((res) => {
        this.errorService.clearErrors();
        this.errorService.addError('Benefits.CODE.90300');
      });
  }
}
